export default __webpack_public_path__ + "static/media/one-pager-icon.fbb72e97.svg";